import React from "react"
import PropTypes from "prop-types"
import "./marketing.scss"
import Button from "../shared/button/text-button"
import cup from "../../images/splashScreens/plusnet-cup.png"
import lock from "../../images/splashScreens/plusnet-lock.png"
import person from "../../images/splashScreens/plusnet-person.png"
import callCenter from "../../images/splashScreens/plusnet-call-center.png"

const MarketingPlusnet = ({ handleButtonClick }) => (
  <div className="marketing-page marketing-page--plusnet">
    <h1>Fixed price guaranteed broadband. We’ll do you proud.</h1>
    <div className="marketing-page--info">
      <div className="marketing-page--info--image">
        <img src="images/marketing/plusnet.png" alt="" />
      </div>
      <div className="marketing-page--info--text">
        <p>
          With fixed price broadband and line rental, end of contract reminders,
          and an account review for peace of mind, Plusnet offers you the best
          value broadband deals.
        </p>
        <p>
          ​ With included safe-guarding, fast routers, flexible contract lengths
          and unlimited downloads, our broadband packages are jam-packed with
          extras that you wouldn’t want to miss.
        </p>
      </div>
    </div>
    <div className="marketing-page--extras">
      <p className="bold">
        There are lots of great benefits to being part of the Plusnet family.
        Only our customers can get all these brilliant deals and products.​
      </p>
      <div className="thumbnailContainer">
        <div>
          <img src={cup} alt="" />
          <p className="bold">Award-winning​</p>

          <p>​ Multi award-winning service</p>
        </div>
        <div>
          <img src={lock} alt="" />
          <p className="bold">Fixed price​</p>
          <p>​ Fixed price broadband and line rental guaranteed</p>
        </div>
        <div>
          <img src={person} alt="" />
          <p className="bold">Account review​</p>
          <p>An account review to check you’re on the best deal.​</p>
        </div>
        <div>
          <img src={callCenter} alt="" />
          <p className="bold">UK-based support</p>
          <p>Our UK based support is there for your 365 days a year</p>
        </div>
      </div>
    </div>
    <div className="marketing-button-container">
      <Button text="Continue" onClick={handleButtonClick} />
    </div>
  </div>
)

MarketingPlusnet.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingPlusnet
